import { AlternativeUserProvider } from "@/contexts/AlternativeUserContext";
import GlobalState from "@/components/GlobalState";
import PageTransition from "@/components/PageTransition";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isSellSupportApp } from "@/lib/auth-storage";
import { getTelegramLaunchData } from "@/hooks/useTelegramLaunchInfo";

/**
 * Layout wrapper specifically for the Primary Mini App (E-Theap Invitation & Management).
 * Preserves the exact authentication, user context, and transition lifecycle without leaking
 * into other independent Mini Apps.
 * If the current session or route belongs to the secondary Sale Support mini app, it redirects back.
 */
export default function PrimaryAppLayout() {
  const location = useLocation();
  if (isSellSupportApp() && !getTelegramLaunchData().startParam?.startsWith("gid_")) {
    return <Navigate to={{ pathname: "/sale-support", search: location.search, hash: location.hash }} replace />;
  }

  return (
    <AlternativeUserProvider>
      <GlobalState>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </GlobalState>
    </AlternativeUserProvider>
  );
}
